import { useSyncExternalStore } from 'react'

const lgQuery =
  typeof window !== 'undefined' ? window.matchMedia('(min-width: 1024px)') : null

function subscribe(cb: () => void) {
  lgQuery?.addEventListener('change', cb)
  return () => lgQuery?.removeEventListener('change', cb)
}

function getSnapshot() {
  return lgQuery?.matches ?? true
}

function getServerSnapshot() {
  return true
}

/** True when viewport is >= lg breakpoint (1024px). */
export function useIsDesktop() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
